module.exports = __webpack_public_path__ + "f44cf855164a49fc31f4898ba671b1cc.png";